(() => {
  const root = document.querySelector('[data-contact-page]');
  const form = root?.querySelector('#ContactUsForm');
  if (!form) return;
  const message = form.querySelector('[data-contact-message]');
  const count = form.querySelector('[data-contact-count]');
  if (message && count) {
    const updateCount = () => { count.textContent = String(message.value.length); };
    message.addEventListener('input', updateCount);
    updateCount();
  }
  const quantity = form.querySelector('[data-contact-quantity]');
  if (quantity) {
    const validateQuantity = () => {
      const valid = !quantity.validity.badInput && (quantity.value === ''
        || (/^\d+$/.test(quantity.value) && Number.isSafeInteger(Number(quantity.value)) && Number(quantity.value) > 0));
      quantity.setCustomValidity(valid ? '' : root.dataset.contactQuantityError);
      return valid;
    };
    quantity.addEventListener('input', validateQuantity);
    form.addEventListener('submit', event => {
      if (!validateQuantity()) {
        event.preventDefault();
        quantity.reportValidity();
      }
    });
    validateQuantity();
  }
  root.querySelector('[data-contact-feedback]')?.focus();
})();
